import { configureStore } from '@reduxjs/toolkit';
import logger from "redux-logger";
import thunk from "redux-thunk";
import promise from "redux-promise-middleware";

import { reducers } from "./reducers";
import CONFIG from "./config";

const middleware = [promise, thunk]
if (CONFIG.DEBUG) middleware.push(logger());
export default configureStore({ reducer: reducers, middleware });
